import styled from "styled-components";
import { SectionTitle, SectionSubtitle } from "components/Style";
import Searched from "./Searched";
import { useState } from "react";
import { TAGS } from "appLauncher";

const Wrapper = styled.div`
  padding-top: 74px;
  padding-bottom: 74px;
  background-color: #e3eefd;
  background-image: url(/assets/big-background.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;

const TagGroup = styled.div`
  display: flex;
  gap: 18px;
  justify-content: center;
  margin-top: 28px;
`;

const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 16px;
  color: #1b2532;
  background: none;
  border-radius: 999px;
  padding: 4px 18px 4px 8px;
  font-weight: bold;
`;

const Card = styled.div`
  width: 780px;
  height: 300px;
  background: #fff;
  border-radius: 7px;
  margin: 40px auto 0 auto;
  box-shadow: 0 4px 24px rgba(38, 64, 237, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 72px;
`;

const CardTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: #1b2532;
  margin-bottom: 28px;
  margin-top: 10px;
`;

const CardInput = styled.input`
  width: 100%;
  height: 48px;
  border: 1.5px solid #e3eefd;
  border-radius: 8px;
  font-size: 17px;
  padding: 0 18px;
  outline: none;
  color: #1b2532;
  background: #f6faff;
  box-sizing: border-box;
  transition: border 0.2s;
  &::placeholder {
    color: #bfc8e0;
    font-size: 16px;
  }
  &:focus {
    border-color: #2640ed;
  }
`;

const CardButton = styled.button`
  width: 210px;
  height: 48px;
  background: #2640ed;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  font-weight: bold;
  margin: 30px 0;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #1b2e99;
  }
`;

const CardTip = styled.div`
  font-size: 12px;
  color: #656565;
  margin-top: 6px;
  text-align: center;
`;

const Description = styled.div`
  max-width: 780px;
  margin: 32px auto 0 auto;
  font-size: 16px;
  color: #1b2532;
  background: none;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

const DescTitle = styled.span`
  font-weight: bold;
  font-size: 18px;
  margin-right: 18px;
  flex-shrink: 0;
`;

const DescList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: left;
  color: rgba(54, 54, 54, 1);
`;

const DescItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
`;

const BlueDot = styled.span`
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2640ed;
  margin-right: 10px;
`;

export default function Verification() {
  const [showSearched, setShowSearched] = useState("");
  const [inputValue, setInputValue] = useState("");
  if (showSearched) return <Searched code={showSearched} />;
  return (
    <Wrapper>
      <SectionTitle>电子保函验真平台</SectionTitle>
      <SectionSubtitle>
        Electronic Guarantee Letter Verification Platform
      </SectionSubtitle>
      <TagGroup>
        {TAGS.map((tag) => (
          <Tag key={tag}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: 8 }}
            >
              <circle cx="12" cy="12" r="12" fill="#2640ed" />
              <path
                d="M6.5 12.5l4 4 8-8"
                stroke="#fff"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
              />
            </svg>
            {tag}
          </Tag>
        ))}
      </TagGroup>
      <Card>
        <CardTitle>在此输入保函编号即可查验</CardTitle>
        <CardInput
          placeholder="请输入您的保函编号"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
        <CardButton onClick={() => setShowSearched(inputValue)}>
          立即查验
        </CardButton>
        <CardTip>如对查验结果有疑问&nbsp;&nbsp;请联系平台客服协助</CardTip>
      </Card>
      <Description>
        <DescTitle>验证方法</DescTitle>
        <DescList>
          <DescItem>
            <BlueDot />
            通过本系统对您所开具保函信息进行查询，无需注册。
          </DescItem>
          <DescItem>
            <BlueDot />
            保函编号在文件的右上角，为字母加数字模式。
          </DescItem>
          <DescItem>
            <BlueDot />
            输入编号后点击查询按键，即刻显示查验结果。
          </DescItem>
          <DescItem>
            <BlueDot style={{ opacity: 0 }} />
            例如:【保函编号:JM01202206171454370020000006】
          </DescItem>
        </DescList>
      </Description>
    </Wrapper>
  );
}
